import { FormikApiStatus, FormikFormStatus } from '@/components/Formik'
import { IRestfulApiService } from '@/lib/apiService'
import { AuthStoreType } from '@/lib/auth/AuthStore'
import { IViewModel, ViewModelAction, ViewModelStatus } from '@/lib/viewModels'
import { GetProtectionByRNumberCommand } from '@/modules/landings/protection/commands/getProtectionByRNumberCommand'
import {
	TrackingNumberFormDataProps,
	TrackingNumberFormSubmit,
} from '@/modules/landings/protection/components/TrackingNumberForm'
import { ProtectionDTO } from '@bookips/solvook-api-shared'
import { Modal } from 'antd'
import { FormikHelpers } from 'formik'
import { runInAction, toJS } from 'mobx'
import { useLocalObservable } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'

type RNumberViewModelProps = {
	apiService?: IRestfulApiService
	authStore?: AuthStoreType
}

type RNumberViewModelStatus = ViewModelStatus & {
	RNumberResult: ProtectionDTO[]
	resultStatus: boolean
} & FormikFormStatus<TrackingNumberFormDataProps, FormikApiStatus>

type RNumberViewModelActions = ViewModelAction & {
	onSubmit: TrackingNumberFormSubmit
	getResult: () => ProtectionDTO[]
}

type RNumberViewModelLocalStore = {}

type IRNumberViewModel = IViewModel<
	RNumberViewModelProps,
	RNumberViewModelStatus,
	RNumberViewModelActions
>

export const RNumberViewModel: IRNumberViewModel = ({ apiService }) => {
	const getProtectionRNumberCommand = useMemo(
		() => new GetProtectionByRNumberCommand(apiService),
		[apiService],
	)
	// const {authStore} = props

	const status = useLocalObservable<RNumberViewModelStatus>(() => ({
		errors: [],
		initialized: false,
		loading: false,
		RNumberResult: [],
		resultStatus: false,
		initialStatus: {
			apiErrors: {},
		},
		initialValues: {
			number1: '',
			number2: '',
			number3: '',
			number4: '',
		},
	}))
	//
	const actions = useLocalObservable<RNumberViewModelActions & RNumberViewModelLocalStore>(
		() => ({
			async initialize(props: {}) {
				status.RNumberResult = []
			},
			async onSubmit(
				values: TrackingNumberFormDataProps,
				formikActions: FormikHelpers<TrackingNumberFormDataProps>,
			) {
				console.log('onSubmit', values)
				// status.resultStatus=true
				const dto = `${values.number1}-${values.number2}-${values.number3}-${values.number4}`
				console.log(dto)
				try {
					const response = await getProtectionRNumberCommand.execute({ r_number: dto })

					if (response.success) {
						status.RNumberResult = [response.protection]
						console.log('status.RNumberResult', toJS(status.RNumberResult))
						status.resultStatus = true
						actions.getResult()
						Modal.success({
							title: '조회 성공',
							content: '조회결과를 확인해주세요',
						})
						runInAction(() => {
							status.resultStatus = true
						})
					} else {
						Modal.error({
							title: '조회에 실패했습니다.',
							content: '잠시 후 다시 시도해주세요.',
						})
					}
				} catch (e) {
					status.RNumberResult = []
					Modal.error({
						title: '조회 결과가 없습니다',
						content: '다시 조회해주세요',
					})
				} finally {
					formikActions.setSubmitting(false)
					formikActions.resetForm()
				}
			},
			getResult() {
				// status.resultStatus = true
				return status.RNumberResult
			},
			dispose(): void {},
		}),
	)

	useEffect(() => {
		actions.initialize({})
	}, [])
	return useLocalObservable(() => ({
		status,
		actions,
	}))
}
